import { i18n } from "@lingui/core";
import React, { useEffect } from 'react';
import { Link } from 'gatsby';
import { useLingui } from '@lingui/react';
import './brand.scss';
import useSiteMetadata from '../../../../hooks/site-metadata-hook';
import shuffleText from '../../../../utils/suffle-text';

var Brand = function Brand(_ref) {
  var place = _ref.place,
      className = _ref.className;

  var _useLingui = useLingui(),
      i18n = _useLingui.i18n;

  var locale = i18n.locale;

  var _useSiteMetadata = useSiteMetadata(),
      titleJa = _useSiteMetadata.titleJa,
      titleEn = _useSiteMetadata.titleEn;

  useEffect(function () {
    var ids = ['brand-title--layout', 'brand-title--header', 'brand-sub--layout', 'brand-sub--header'];
    ids.forEach(function (id) {
      shuffleText(id);
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "brand " + (className ? className : '')
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/" + locale
  }, /*#__PURE__*/React.createElement("h1", {
    className: "brand__title",
    id: "brand-title--" + place
  }, locale === 'en' ? titleEn : titleJa), /*#__PURE__*/React.createElement("h3", {
    className: "brand__sub",
    id: "brand-sub--" + place
  }, i18n._(
  /*i18n*/
  i18n._("web developer")))));
};

export default Brand;